import { toLocalISO } from 'routes/Pages/GenTask/components/SharedFormFields';

export const addEditWoodChipFormDataFields = [
  {
    name: 'wH_DocketNumber',
    typeOfInp: 'input',
    textFieldType: 'number',
    label: 'Worrell Docket Number/Load ID',
    width: 6,
    required: true,
  },
  {
    name: 'finishWeight',
    typeOfInp: 'input',
    textFieldType: 'number',
    label: 'Finish Weight',
    width: 6,
    required: true,
  },
  {
    name: 'customer',
    typeOfInp: 'select',

    label: 'Customer',
    width: 6,
    required: true,
  },
  {
    name: 'sP_Number',
    typeOfInp: 'input',
    textFieldType: 'text',
    label: 'SP Number',
    width: 6,
    required: true,
  },
  {
    name: 'mC_Percent',
    typeOfInp: 'input',
    textFieldType: 'number',
    label: 'MC Percent',
    width: 6,
    required: true,
    disabled: false, // This field is disabled as per the original code
  },
  {
    name: 'finishDate',
    typeOfInp: 'input',
    textFieldType: 'dateTime-local',
    label: 'Finish Date',
    width: 6,
    required: true,
  },
  {
    name: 'startingWeight',
    typeOfInp: 'input',
    textFieldType: 'number',
    label: 'Starting Weight',
    width: 6,
    required: true,
  },
  {
    name: 'cookTimeHours',
    typeOfInp: 'input',
    textFieldType: 'number',
    label: 'Cook Time (Hours)',
    width: 6,
    required: true,
  },
];

export const InitialAddEditWoodChipFormData = {
  id: null,
  whDocketNumber: '',
  finishWeight: '',
  customer: '',
  spNumber: '',
  mcPercent: '',
  finishDate: toLocalISO(), // Default to current date and time
  startingWeight: '',
  cookTimeHours: '',
};

export const customer = [
  { label: 'Aurivo', value: 'Aurivo' },
  { label: 'Bord Na Mona', value: 'Bord Na Mona' },
  { label: 'Derryarkin', value: 'Derryarkin' },
  { label: 'Edenderry', value: 'Edenderry' },
  { label: 'Shamrock', value: 'Shamrock' },
  { label: 'Log Yard Tullamore', value: 'Log Yard Tullamore' },
  { label: 'None', value: 'None' },
  { label: 'frenchpark ecc', value: 'frenchpark ecc' },
  { label: 'Add Option', value: 'Add Option' },
];
export const woodChipFormDropDownData = {
  customer: customer,
};
